import React, { useEffect, useState } from "react";
import { TranslationObject } from "../../../../models/translationModal";
import { ProfilePayload } from "../../../../models/userModels";
import { useUpdateEmailSubscribeMutation } from "../../../../store/user/user.api";

interface EmailMailingSettingsProps {
    entities?: TranslationObject;
    profile?: ProfilePayload;
}

export const EmailMailingSettings: React.FC<EmailMailingSettingsProps> = ({
    entities,
    profile,
}) => {
    const deviEnabledDefault = profile?.email_subscribe?.devi ?? true;
    const [deviEnabled, setDeviEnabled] = useState(deviEnabledDefault);
    const [updateEmailSubscribe, { isLoading }] =
        useUpdateEmailSubscribeMutation();

    useEffect(() => {
        setDeviEnabled(profile?.email_subscribe?.devi ?? true);
    }, [profile?.email_subscribe?.devi]);

    const handleDeviSubscribeChange = async (nextValue: boolean) => {
        if (isLoading || nextValue === deviEnabled) {
            return;
        }

        const previousValue = deviEnabled;
        setDeviEnabled(nextValue);

        try {
            await updateEmailSubscribe({
                email_subscribe: {
                    devi: nextValue,
                },
            }).unwrap();
        } catch {
            setDeviEnabled(previousValue);
        }
    };

    if (profile?.user_role !== "specialist") {
        return null;
    }

    return (
        <div className="specialist-profile__block">
            <div className="specialist-profile__col">
                <h3 className="specialist-profile__subtitle title title--h3">
                    {entities?.specialist_details_email_mailing_title?.value}
                </h3>
            </div>
            <div className="profile-block grey-card">
                <div className="profile-block__row specialist-profile__email-subscribe-row">
                    <div className="specialist-profile__email-subscribe-label">
                        <p className="text profile-block__text">
                            {
                                entities
                                    ?.specialist_details_email_mailing_devi_posts
                                    ?.value
                            }
                        </p>
                        <p className="text color-grey">
                            {
                                entities
                                    ?.specialist_details_email_mailing_devi_posts_description
                                    ?.value
                            }
                        </p>
                    </div>
                    <div className="specialist-profile__email-subscribe-control">
                        <div className="custom-toggle custom-toggle--switch">
                            <label>
                                <input
                                    type="checkbox"
                                    name="devi_email_subscribe"
                                    checked={deviEnabled}
                                    disabled={isLoading}
                                    onChange={(event) =>
                                        void handleDeviSubscribeChange(
                                            event.target.checked,
                                        )
                                    }
                                />
                                <span className="custom-toggle__icon" />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
